import React, { useMemo, useState, useEffect } from 'react';
import styles from './styles/styles.module.scss';

const Fade = ({ children, onExitDone, fadeOutOnly = false }) => {
  const [opacity, setOpacity] = useState(fadeOutOnly ? 1 : 0);
  const [isMounted, toggleIsMounted] = useState(true);

  useEffect(() => {
    if (fadeOutOnly) {
      return;
    }

    const fadeTimeout = setTimeout(() => {
      setOpacity(1);
    }, 100);

    return () => {
      clearTimeout(fadeTimeout);
    };
  }, []);

  useEffect(() => {
    if (isMounted) {
      return;
    }

    setOpacity(0);
  }, [isMounted]);

  const animationStyles = useMemo(() => {
    let style = `${styles.baseState}`;

    if (opacity === 1) {
      style += ` ${styles.enterDone}`;
    }

    return style;
  }, [opacity]);

  const onTransitionEnd = e => {
    if (!isMounted) {
      onExitDone();
    }
  };

  const unMount = () => {
    toggleIsMounted(false);
  };

  return <>{children(animationStyles, onTransitionEnd, unMount)}</>;
};

export default Fade;
